<div class="preview">
  <img *ngIf="imageUrl" [src]="imageUrl" [alt]="file.name" />
  <mat-icon *ngIf="!imageUrl" [svgIcon]="fileIcon" inline="false"></mat-icon>
</div>
<mat-form-field class="example-full-width" [formGroup]="formGroup">
  <mat-label>{{ 'mobile-upload.upload.filename' | translate }}</mat-label>
  <input matInput [formControlName]="inputName" />
  <span matSuffix class="suffix-aligned-with-input">.{{fileExtension}}</span>
  <mat-error>
    {{ formGroup.get(inputName) ? ('mobile-upload.upload.filename-required' | translate) : '' }}
  </mat-error>
</mat-form-field>
